import { OVERRIDE_ENV_COOKIE, parseOverrideEnv } from '@tapp/utilities/src/apiEnv/apiEnv';

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();

  // Match the server-side gate so production deploys ignore the param.
  if (!import.meta.dev && config.public.STAGE === 'production') return;

  const route = useRoute();
  const raw = route.query['override-env'];
  const rawValue = Array.isArray(raw) ? raw[0] : raw;
  // The literal `default` explicitly clears an active override; unknown values are ignored.
  const next = rawValue === 'default' ? null : parseOverrideEnv(rawValue);
  if (next === undefined) return;

  const cookie = useCookie<string | null>(OVERRIDE_ENV_COOKIE, { default: () => null });
  if (cookie.value === next) return;

  cookie.value = next;

  // Strip the param and reload so SSR refetches against the new upstream.
  const url = new URL(window.location.href);
  url.searchParams.delete('override-env');
  window.location.replace(url.toString());
});
